import { useEffect, useRef, useState } from "react";
import Image from "src/Components/Common/Image";
import store from "src/Reducers/store";
import { useSelector } from "react-redux";
import "./ConversationEffect.css";

interface ConversationEffectProps {
  images: { image: string; imageStyle: React.CSSProperties | {}; effect?: string }[];
  pageNumber: number;
  times?: number[];
  conversationStyle?: React.CSSProperties;
}

const ConversationEffect = ({ images, times, pageNumber, conversationStyle = {} }: ConversationEffectProps) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const currentPage = useSelector(() => store.getState().appReducer.currentPage);
  const bubbles = containerRef.current?.querySelectorAll(".message-bubble") || [];

  const [adjustedTimes, setAdjustedTimes] = useState<number[]>([]);

  useEffect(() => {
    const adjustTimes = () => {
      if (!times || times.length < images.length) {
        const newTimes = times ? [...times] : [0];
        while (newTimes.length < images.length) newTimes.push(900);
        return newTimes;
      } else return times;
    };

    setAdjustedTimes(adjustTimes());
  }, [images, times]);

  useEffect(() => {
    bubbles.forEach((bubble, index) => {
      bubble.classList.remove(images[index].effect ? (images[index].effect as string) : "animate-up");
    });
    if (pageNumber === currentPage) {
      startEffect();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageNumber, currentPage]);

  const startEffect = () => {
    bubbles.forEach((bubble, index) => {
      setTimeout(
        () => bubble.classList.add(images[index].effect ? (images[index].effect as string) : "animate-up"),
        adjustedTimes.slice(0, index + 1).reduce((sum, num) => sum + num, 0)
      );
    });

    if (containerRef.current) {
      containerRef.current.scrollTop = containerRef.current.scrollHeight;
    }
  };
  return (
    <div className="conversation" style={conversationStyle} ref={containerRef}>
      {images.map((item, index) => (
        <div key={index} className={"message-bubble"} style={item.imageStyle}>
          <Image imagePath={item.image} />
        </div>
      ))}
    </div>
  );
};

export default ConversationEffect;
